.root {
	/* rail = glyph + one padding per side, minus the 1px border it replaces: 15*2 + 16 - 2 */
	--alert-rail-width: calc(var(--alert-padding) * 2 + var(--alert-icon-size) - 2px);

	position: relative;
	margin-bottom: var(--line-height-base);
	padding: var(--alert-padding) calc(var(--alert-padding) + 5px);
	border: 1px solid transparent;
	border-radius: var(--border-radius-base);
}

.root > p,
.root > ul {
	margin-bottom: 0;
}

.root > p + p {
	margin-top: 5px;
}

.primary {
	background-color: var(--alert-primary-bg);
	border-color: var(--alert-primary-border);
	color: var(--alert-primary-text);
}

.success {
	background-color: var(--alert-success-bg);
	border-color: var(--alert-success-border);
	color: var(--alert-success-text);
}

.info {
	background-color: var(--alert-info-bg);
	border-color: var(--alert-info-border);
	color: var(--alert-info-text);
}

.warning {
	background-color: var(--alert-warning-bg);
	border-color: var(--alert-warning-border);
	color: var(--alert-warning-text);
}

.danger {
	background-color: var(--alert-danger-bg);
	border-color: var(--alert-danger-border);
	color: var(--alert-danger-text);
}

.iconLeft {
	border-left-width: var(--alert-rail-width);
}

.iconRight {
	border-right-width: var(--alert-rail-width);
}

.icon {
	position: absolute;
	top: 50%;
	width: var(--alert-rail-width);
	margin-top: calc(var(--alert-icon-size) * -0.5);
	color: #fff;
	font-size: var(--alert-icon-size);
	line-height: 1;
	text-align: center;
}

/* negative offset: the rail lies outside the padding box the icon is positioned in */
.iconLeft > .icon {
	left: calc(var(--alert-rail-width) * -1);
}

.iconRight > .icon {
	right: calc(var(--alert-rail-width) * -1);
}

.title {
	margin-top: 0;
	margin-bottom: 5px;
	color: inherit;
	font-weight: 500;
}
